// @flow

import React from 'react';
import { connect } from 'react-redux';
import { getFAQCategory, getFAQParent } from '@leasen_nl/listo/src/store/routes';
import type { FAQCategoryWithCategories, FAQParent } from '@leasen_nl/listo/src/types/faq';
import ActiveSubCategory from './activeSubCategory';

type StateProps = {|
  rootCategory: ?FAQCategoryWithCategories,
  parent: ?FAQParent,
|};

type Props = StateProps;

const ActiveSubCategoryContainer = ({
  rootCategory,
  parent,
}: Props) => {
  if (!rootCategory) {
    // When FAQ rootCategory === null, exit
    return null;
  }

  return (
    <ActiveSubCategory
      rootCategory={rootCategory}
      parent={parent}
    />
  );
};

const mapStateToProps = (state): StateProps => ({
  rootCategory: getFAQCategory(state),
  parent: getFAQParent(state),
});

export default connect<any, any, StateProps, any, any, any>(
  mapStateToProps,
)(ActiveSubCategoryContainer);
